import { render, staticRenderFns } from "./ContractViewTimelineItemClosed.vue?vue&type=template&id=5a706ace&"
import script from "./ContractViewTimelineItemClosed.vue?vue&type=script&lang=js&"
export * from "./ContractViewTimelineItemClosed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTimelineItem } from 'vuetify/lib'
installComponents(component, {
  VFlex,
  VLayout,
  VTimelineItem,
})
